import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, withCtx as _withCtx, resolveDirective as _resolveDirective, createTextVNode as _createTextVNode, createVNode as _createVNode, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  class: "table"
};
const _hoisted_2 = ["src", "onMousemove", "onMouseout"];
const _hoisted_3 = ["src"];
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "d-play"
};
const _hoisted_6 = {
  class: "d-st"
};
const _hoisted_7 = {
  class: "m-r-10"
};
const _hoisted_8 = {
  class: "dialog-footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_vxe_column = _resolveComponent("vxe-column");
  const _component_vxe_colgroup = _resolveComponent("vxe-colgroup");
  const _component_el_switch = _resolveComponent("el-switch");
  const _component_el_button = _resolveComponent("el-button");
  const _component_vxe_table = _resolveComponent("vxe-table");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_pagination = _resolveComponent("el-pagination");
  const _component_el_row = _resolveComponent("el-row");
  const _component_EditSpuSkuDiaLog = _resolveComponent("EditSpuSkuDiaLog");
  const _component_LanguageTiptool = _resolveComponent("LanguageTiptool");
  const _component_BatchEdit = _resolveComponent("BatchEdit");
  const _component_DownLoadImportTemplate = _resolveComponent("DownLoadImportTemplate");
  const _component_el_dialog = _resolveComponent("el-dialog");
  const _directive_allow = _resolveDirective("allow");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_vxe_table, {
    ref: "getDom",
    border: "",
    resizable: "",
    "scroll-x": {
      enabled: false
    },
    "row-config": {
      isHover: true
    },
    "scroll-y": {
      enabled: false
    },
    height: "600",
    data: _ctx.data.list,
    onCheckboxChange: _ctx.getSelectRow,
    onCheckboxAll: _ctx.getSelectRow
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.listHeader, (item, index) => {
      return _openBlock(), _createElementBlock("div", {
        key: index
      }, [item.type == 'checkbox' ? (_openBlock(), _createBlock(_component_vxe_column, {
        key: 0,
        type: item.type,
        fixed: item.fixed,
        align: item.align,
        width: item.width
      }, null, 8, ["type", "fixed", "align", "width"])) : _createCommentVNode("", true), item.type == 'group' ? (_openBlock(), _createBlock(_component_vxe_colgroup, {
        key: 1,
        fixed: item.fixed,
        align: item.align,
        title: item.title
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (itemChild, indexChild) => {
          return _openBlock(), _createElementBlock("div", {
            key: indexChild
          }, [itemChild.type == 'col' ? (_openBlock(), _createBlock(_component_vxe_column, {
            key: 0,
            field: itemChild.field,
            title: itemChild.title,
            width: itemChild.width,
            align: itemChild.align,
            "show-header-overflow": "",
            "show-overflow": ""
          }, null, 8, ["field", "title", "width", "align"])) : _createCommentVNode("", true), itemChild.type == 'img' ? (_openBlock(), _createBlock(_component_vxe_column, {
            key: 1,
            field: itemChild.field,
            title: itemChild.title,
            width: itemChild.width,
            align: itemChild.align
          }, {
            default: _withCtx(scope => [_createElementVNode("img", {
              src: scope.row.image ? _ctx.data.cdn + scope.row.image : _ctx.defaulImg,
              class: "avatar",
              onMousemove: $event => _ctx.entryCellShowImg($event, scope.row),
              onMouseout: $event => _ctx.leaveCellBlurImg(scope.row)
            }, null, 40, _hoisted_2), _ctx.data.showImgUrl ? _withDirectives((_openBlock(), _createElementBlock("view", {
              key: 0,
              class: "img-show position-f",
              style: _normalizeStyle(_ctx.data.top)
            }, [_createElementVNode("img", {
              src: _ctx.data.cdn + _ctx.data.showImgUrl
            }, null, 8, _hoisted_3)], 4)), [[_vShow, scope.row.showImg]]) : _createCommentVNode("", true)]),
            _: 2
          }, 1032, ["field", "title", "width", "align"])) : _createCommentVNode("", true)]);
        }), 128))]),
        _: 2
      }, 1032, ["fixed", "align", "title"])) : _createCommentVNode("", true), item.type == 'group-allow' ? _withDirectives((_openBlock(), _createBlock(_component_vxe_colgroup, {
        key: 2,
        fixed: item.fixed,
        align: item.align,
        title: item.title,
        width: item.width
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (itemChild, indexChild) => {
          return _openBlock(), _createElementBlock("div", {
            key: indexChild
          }, [itemChild.type == 'col' ? (_openBlock(), _createBlock(_component_vxe_column, {
            key: 0,
            field: itemChild.field,
            title: itemChild.title,
            width: itemChild.width,
            align: itemChild.align,
            "show-header-overflow": "",
            "show-overflow": ""
          }, null, 8, ["field", "title", "width", "align"])) : _createCommentVNode("", true), itemChild.type == 'img' ? (_openBlock(), _createBlock(_component_vxe_column, {
            key: 1,
            field: itemChild.field,
            title: itemChild.title,
            width: itemChild.width,
            align: itemChild.align
          }, {
            default: _withCtx(scope => [_createElementVNode("img", {
              src: scope.row.package_img ? _ctx.data.cdn + scope.row.package_img : _ctx.defaulImg,
              class: "avatar",
              onError: _cache[0] || (_cache[0] = e => {
                e.target.src = _ctx.defaulImg;
              })
            }, null, 40, _hoisted_4)]),
            _: 2
          }, 1032, ["field", "title", "width", "align"])) : _createCommentVNode("", true)]);
        }), 128))]),
        _: 2
      }, 1032, ["fixed", "align", "title", "width"])), [[_directive_allow, 'NewCost.NewCostFinance']]) : _createCommentVNode("", true), item.type == 'col' ? (_openBlock(), _createBlock(_component_vxe_column, {
        key: 3,
        field: item.field,
        title: item.title,
        width: item.width,
        align: item.align,
        "show-header-overflow": "",
        "show-overflow": ""
      }, null, 8, ["field", "title", "width", "align"])) : _createCommentVNode("", true), item.type == 'col-allow' ? _withDirectives((_openBlock(), _createBlock(_component_vxe_column, {
        key: 4,
        field: item.field,
        title: item.title,
        width: item.width,
        align: item.align,
        "show-header-overflow": "",
        "show-overflow": ""
      }, null, 8, ["field", "title", "width", "align"])), [[_directive_allow, 'NewCost.AddSpu']]) : _createCommentVNode("", true), item.type == 'group-all' ? _withDirectives((_openBlock(), _createBlock(_component_vxe_column, {
        key: 5,
        field: item.field,
        title: item.title,
        width: item.width,
        align: item.align,
        "show-header-overflow": "",
        "show-overflow": ""
      }, null, 8, ["field", "title", "width", "align"])), [[_directive_allow, 'NewCost.NewCostFinance']]) : _createCommentVNode("", true), item.type == 'template' ? (_openBlock(), _createBlock(_component_vxe_column, {
        key: 6,
        title: item.title,
        width: item.width,
        align: item.align,
        fixed: item.fixed
      }, {
        default: _withCtx(scope => [item.son == 'switch' ? (_openBlock(), _createBlock(_component_el_switch, {
          key: 0,
          onChange: $event => _ctx.switchChange(scope.row),
          modelValue: scope.row.status,
          "onUpdate:modelValue": $event => scope.row.status = $event,
          class: "ml-2",
          "active-value": 1,
          "inactive-value": 0
        }, null, 8, ["onChange", "modelValue", "onUpdate:modelValue"])) : _createCommentVNode("", true), item.son == 'edit' ? (_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          type: "text",
          onClick: $event => _ctx.editCom(scope.row, 'spu')
        }, {
          default: _withCtx(() => _cache[11] || (_cache[11] = [_createTextVNode("编辑SPU")])),
          _: 2,
          __: [11]
        }, 1032, ["onClick"])) : _createCommentVNode("", true), item.son == 'edit' ? (_openBlock(), _createBlock(_component_el_button, {
          key: 2,
          type: "text",
          onClick: $event => _ctx.editCom(scope.row, 'sku')
        }, {
          default: _withCtx(() => _cache[12] || (_cache[12] = [_createTextVNode("编辑SKU")])),
          _: 2,
          __: [12]
        }, 1032, ["onClick"])) : _createCommentVNode("", true)]),
        _: 2
      }, 1032, ["title", "width", "align", "fixed"])) : _createCommentVNode("", true), item.type == 'template-allow' ? _withDirectives((_openBlock(), _createBlock(_component_vxe_column, {
        key: 7,
        title: item.title,
        width: item.width,
        align: item.align,
        fixed: item.fixed
      }, {
        default: _withCtx(scope => [item.son == 'switch' ? (_openBlock(), _createBlock(_component_el_switch, {
          key: 0,
          onChange: $event => _ctx.switchChange(scope.row),
          modelValue: scope.row.status,
          "onUpdate:modelValue": $event => scope.row.status = $event,
          class: "ml-2",
          "active-value": 1,
          "inactive-value": 0
        }, null, 8, ["onChange", "modelValue", "onUpdate:modelValue"])) : _createCommentVNode("", true), item.son == 'edit' ? (_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          type: "text",
          onClick: $event => _ctx.editCom(scope.row, 'spu')
        }, {
          default: _withCtx(() => _cache[13] || (_cache[13] = [_createTextVNode("编辑SPU")])),
          _: 2,
          __: [13]
        }, 1032, ["onClick"])) : _createCommentVNode("", true), item.son == 'edit' ? (_openBlock(), _createBlock(_component_el_button, {
          key: 2,
          type: "text",
          onClick: $event => _ctx.editCom(scope.row, 'sku')
        }, {
          default: _withCtx(() => _cache[14] || (_cache[14] = [_createTextVNode("编辑SKU")])),
          _: 2,
          __: [14]
        }, 1032, ["onClick"])) : _createCommentVNode("", true)]),
        _: 2
      }, 1032, ["title", "width", "align", "fixed"])), [[_directive_allow, 'NewCost.EditSku']]) : _createCommentVNode("", true)]);
    }), 128))]),
    _: 1
  }, 8, ["data", "onCheckboxChange", "onCheckboxAll"]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_row, null, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 24
    }, {
      default: _withCtx(() => [_createVNode(_component_el_row, {
        gutter: 10
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 3
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createElementVNode("span", _hoisted_7, "SPU：" + _toDisplayString(_ctx.data.spu_count) + "条", 1), _createElementVNode("span", null, "SKU：" + _toDisplayString(_ctx.data.sku_count) + "条", 1)])]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 19
        }, {
          default: _withCtx(() => [_createVNode(_component_el_pagination, {
            class: "m-t-20 m-b-20",
            "current-page": _ctx.data.page,
            "page-sizes": [50, 100, 150],
            "page-size": _ctx.data.size,
            layout: " sizes, prev, pager, next, jumper",
            total: _ctx.data.count,
            onSizeChange: _ctx.handleSizeChange,
            onCurrentChange: _ctx.handleCurrentChange,
            small: ""
          }, null, 8, ["current-page", "page-size", "total", "onSizeChange", "onCurrentChange"])]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  })]), _createVNode(_component_EditSpuSkuDiaLog, {
    isEditSpuSkuShow: _ctx.data.isEditSpuSkuShow,
    "onUpdate:isEditSpuSkuShow": _cache[1] || (_cache[1] = $event => _ctx.data.isEditSpuSkuShow = $event),
    selectList: _ctx.data.selectList,
    "onUpdate:selectList": _cache[2] || (_cache[2] = $event => _ctx.data.selectList = $event),
    excludespulist: _ctx.data.excludespulist,
    "onUpdate:excludespulist": _cache[3] || (_cache[3] = $event => _ctx.data.excludespulist = $event),
    onGetSpuSkuValue: _ctx.getSpuSkuValue
  }, null, 8, ["isEditSpuSkuShow", "selectList", "excludespulist", "onGetSpuSkuValue"]), _createVNode(_component_LanguageTiptool, {
    isShowLanguageTipTool: _ctx.data.isLanguageShow,
    "onUpdate:isShowLanguageTipTool": _cache[4] || (_cache[4] = $event => _ctx.data.isLanguageShow = $event),
    onNoticeShowBatch: _ctx.noticeShowBatch
  }, null, 8, ["isShowLanguageTipTool", "onNoticeShowBatch"]), _createVNode(_component_BatchEdit, {
    isBatchEditShow: _ctx.data.isBatchEditShow,
    "onUpdate:isBatchEditShow": _cache[5] || (_cache[5] = $event => _ctx.data.isBatchEditShow = $event),
    attrlist: _ctx.data.muleditAttr,
    "onUpdate:attrlist": _cache[6] || (_cache[6] = $event => _ctx.data.muleditAttr = $event),
    cusTitle: _ctx.data.cusTitle,
    "onUpdate:cusTitle": _cache[7] || (_cache[7] = $event => _ctx.data.cusTitle = $event),
    onGetBatchEditObj: _ctx.getBatchEditObj
  }, null, 8, ["isBatchEditShow", "attrlist", "cusTitle", "onGetBatchEditObj"]), _createVNode(_component_DownLoadImportTemplate, {
    isDownloadShow: _ctx.data.isDownloadShow,
    "onUpdate:isDownloadShow": _cache[8] || (_cache[8] = $event => _ctx.data.isDownloadShow = $event)
  }, null, 8, ["isDownloadShow"]), _createVNode(_component_el_dialog, {
    "model-value": _ctx.data.isShowDelete,
    "close-on-click-modal": false,
    "close-on-press-escape": false,
    "show-close": false,
    title: "删除提示",
    width: "440px",
    center: ""
  }, {
    footer: _withCtx(() => [_createElementVNode("span", _hoisted_8, [_createVNode(_component_el_button, {
      onClick: _cache[9] || (_cache[9] = $event => _ctx.deleteCommon('cancel'))
    }, {
      default: _withCtx(() => _cache[15] || (_cache[15] = [_createTextVNode("取消")])),
      _: 1,
      __: [15]
    }), _createVNode(_component_el_button, {
      type: "primary",
      onClick: _cache[10] || (_cache[10] = $event => _ctx.deleteCommon('sure'))
    }, {
      default: _withCtx(() => _cache[16] || (_cache[16] = [_createTextVNode("确定")])),
      _: 1,
      __: [16]
    })])]),
    default: _withCtx(() => [_cache[17] || (_cache[17] = _createElementVNode("span", null, _toDisplayString('确定删除所选产品吗？'), -1))]),
    _: 1,
    __: [17]
  }, 8, ["model-value"])]);
}